import { Trans } from 'react-i18next';
import { resolveBranding } from '../../config/branding';

function AppFooter({ branding: brandingData }) {
  const branding = resolveBranding(brandingData);

  return (
    <footer>
      <div className="container text-center">
        <small>
          {branding.companyName}
        </small><br/>
        <small>
          <a href={branding.privacyUrl}>
            <Trans i18nKey="footer.data_protection_terms" />
          </a> &nbsp;·&nbsp;
          <a href={branding.imprintUrl}>
            <Trans i18nKey="footer.imprint" />
          </a>
        </small><br />
        <small className="text-muted">
          {branding.shortName} Aufwandserstattung WebApp v{ process.env.REACT_APP_VERSION }
        </small>
      </div>
    </footer>
  );
}

export default AppFooter;
